angular.module('lsnBase.tryEscapeHtml', []);